import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPlaatsconflict = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M17.24 4.61C15.74 3.21 13.98 2.5 12 2.5C10.02 2.5 8.26 3.21 6.76 4.61C5.24 6.03 4.5 7.87 4.5 10.26C4.5 11.83 5.13 13.56 6.36 15.4C7.75 17.48 9.64 19.6 11.67 21.38L12 21.67L12.33 21.38C14.36 19.61 16.25 17.48 17.64 15.4C18.87 13.56 19.5 11.83 19.5 10.26C19.5 7.87 18.76 6.02 17.24 4.61ZM16.81 14.85C15.54 16.75 13.84 18.68 12 20.34C10.16 18.68 8.46 16.75 7.19 14.85C6.07 13.18 5.5 11.63 5.5 10.27C5.5 8.18 6.14 6.57 7.44 5.35C8.75 4.13 10.28 3.51 12 3.51C13.72 3.51 15.25 4.13 16.56 5.35C17.87 6.57 18.5 8.18 18.5 10.27C18.5 11.64 17.93 13.18 16.81 14.85Z' />
    <path d='M12 7C10.35 7 9 8.35 9 10C9 11.65 10.35 13 12 13C13.65 13 15 11.65 15 10C15 8.35 13.65 7 12 7ZM12 12C10.9 12 10 11.1 10 10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 11.1 13.1 12 12 12Z' />
  </svg>
);
export default SvgPlaatsconflict;
